// extracted by mini-css-extract-plugin
export var borderRadius = "_4j-4";
export var large = "_4j-3";
export var logoContainer = "_4j-0";
export var nameLogo = "_4j-2";
export var small = "_4j-1";